import { render, staticRenderFns } from "./StudyUnitForm.vue?vue&type=template&id=35504407&scoped=true"
import script from "./StudyUnitForm.vue?vue&type=script&lang=js"
export * from "./StudyUnitForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=35504407&prod&scoped=true&lang=css&external"
import style1 from "./StudyUnitForm.vue?vue&type=style&index=1&id=35504407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35504407",
  null
  
)

export default component.exports